'use client';

import { AchievementDetailSheet } from '@/screens/AchievementsScreen/components/AchievementDetailSheet';
import { useAchievementSheetKey, useCloseAchievementSheet } from '@/stores/achievementSheetStore';

/**
 * App-level achievement detail sheet, driven by `achievementSheetStore`.
 * Mounted once per runtime so the unlock toast can open a trophy from any
 * screen. Renders nothing until a key is set (BottomSheet returns null).
 */
export function GlobalAchievementSheet() {
  const openKey = useAchievementSheetKey();
  const close = useCloseAchievementSheet();
  return <AchievementDetailSheet achievementKey={openKey} onClose={close} />;
}
